import { motion } from 'framer-motion';

interface AnimatedGradientBarProps {
    isThinking: any;
}

export function AnimatedGradientBar({ isThinking }: AnimatedGradientBarProps) {
    return (
        <div className="absolute top-0 left-0 w-full h-[6px] z-20 overflow-hidden">
            <motion.div
                className="absolute top-0 left-0 h-full"
                style={{
                    width: '200%',
                    background: 'linear-gradient(90deg, #0284C7 0%, #5EEAD4 12.5%, #6D28D9 31.25%, #4F46E5 50%, #0284C7 62.5%, #5EEAD4 75%, #6D28D9 93.75%, #4F46E5 100%)'
                }}
                animate={{
                    x: ['-50%', '0%']
                }}
                transition={{
                    duration: isThinking ? 2 : 8,
                    repeat: Infinity,
                    ease: "linear"
                }}
            />
        </div>
    );
}
